exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".head[data-v-deeb2252] {\n  padding-bottom: 10px;\n}\n.content[data-v-deeb2252] {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.foot[data-v-deeb2252] {\n  width: 100%;\n  padding-top: 10px;\n  display: flex;\n  justify-content: flex-end;\n}\n@media (max-width: 992px) {\n.content[data-v-deeb2252] {\n    flex-flow: column wrap;\n}\n.content > *[data-v-deeb2252] {\n      width: 100%;\n}\n}\n", ""]);

// exports
